import z from 'zod';

export const mileageSchema = z.union([
  z.literal('Kilometres'),
  z.literal('Miles'),
]);
